import { useParams } from 'react-router-dom';

import { Card, PageWrapper } from '@ingrid/luterkort-react';

import { useShipmentDetailsQuery } from '../queries';
import { Addresses } from './addresses';
import { CarrierContract } from './carrier-contract';
import { CarrierProduct } from './carrier-product';
import { Consignment } from './consignment';
import { CustomsDeclaration } from './customs-declaration';
import { Deliveries } from './deliveries';
import { Details } from './details';
import { Header } from './header';
import { Metadata } from './metadata';
import { References } from './references';
import { Status } from './status';

export function DetailsPage() {
  const { id } = useParams();
  const shipment = useShipmentDetailsQuery({ id });

  if (!shipment) {
    return null;
  }

  return (
    <PageWrapper gap="lg" variant="center">
      <Header shipment={shipment} />

      <Card.List>
        <Status status={shipment.status.type} />
        <References shipment={shipment} />
        <Deliveries shipment={shipment} />
        <Addresses shipment={shipment} />
        <Consignment shipment={shipment} />
        <CustomsDeclaration shipment={shipment} />
        <CarrierProduct shipment={shipment} />
        <CarrierContract shipment={shipment} />
        <Metadata shipment={shipment} />
        <Details shipment={shipment} />
      </Card.List>
    </PageWrapper>
  );
}
